document.addEventListener("DOMContentLoaded", () => {
  const item = document.querySelector('.running-line__item');
  const wrapper = document.querySelector('.running-line__wrapper');

  if (item && wrapper) {
    const width = item.clientWidth + 30;

    const style = document.createElement('style');
    style.innerHTML = `
      @keyframes horizontal-scroll {
        from {
          transform: translateX(0);
        }
        to {
          transform: translateX(-${width}px);
        }
      }
      .running-line__wrapper {
        animation-name: horizontal-scroll;
      }
    `;
    
    document.head.appendChild(style);
  }
});